<template>
  <div class="mgt-10px VueTables">
    <div class="table-responsive">
      <v-client-table :data="avoirsLies"
                      :columns="columns"
                      :options="options"
                      ref="tableAvoirsLies">
        <div slot="dateDevisCommande" slot-scope="props">
          {{ props.row.dateDevisCommande | formatDate }}
        </div>
        <div slot="montantTtc" slot-scope="props" class="right">
          {{ props.row.montantTtc | formatDevise }}
        </div>
        <div slot="etat" slot-scope="props">
          {{ getEtat(props.row.etat) }}
        </div>
        <div slot="code" slot-scope="props">
          <router-link-blank
            :to="{name: getRouteName, params: {id: props.row.id}}"
            :message="props.row.code">
          </router-link-blank>
        </div>
      </v-client-table>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { FACTURE_ETAT } from '@/configuration/facture/factureConf';
import { SENS_ACHAT } from '@/configuration/devisConf';
import { MODULE_TLPE } from '@/configuration/gabed/titreRecette/titreRecetteConf';

export default {
  props: {
    factureDetail: {
      type: Object,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    avoirsLies() {
      return this.factureDetail.avoirsAffectes;
    },
    isAchat() {
      return this.factureDetail.sens === SENS_ACHAT;
    },
    getRouteName() {
      if (this.$route.name === 'c.bodac.factures-achatVenteInterne') return 'c.bodac.factures-achatVenteInterne';
      if (this.$route.name === 'c.bodac.factures-venteInterne') return 'c.bodac.factures-venteInterne';
      if (this.isAchat) {
        if (this.factureDetail.module === MODULE_TLPE) {
          return 'c.gabed.titre_recette';
        }
        return 'c.baux.facture_achat';
      }
      return 'c.bodac.factures';
    },
    columns() {
      return ['code', 'dateDevisCommande', 'etat', 'montantTtc'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          code: this.$i18n.t('detailFacture.avoirsLies.tab.code'),
          dateDevisCommande: this.$i18n.t('detailFacture.avoirsLies.tab.date'),
          etat: this.$i18n.t('detailFacture.avoirsLies.tab.etat'),
          montantTtc: this.$i18n.t('detailFacture.avoirsLies.tab.montant'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
      };
    },
  },
  methods: {
    getEtat(etat) {
      const etatFind = FACTURE_ETAT.find((el) => {
        return el.code === etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : '';
    },
  },
};
</script>
